import React, { useContext, useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import Header from "./commonComponents/Header";
import Sidebar from "./commonComponents/Sidebar";
import { RootContext } from "../context";
import { observer } from "mobx-react-lite";

const Layout: React.FC = observer(() => {
  const { authStore } = useContext(RootContext);
  const { isAuthenticated } = authStore;

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="h-screen flex flex-col overflow-hidden bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      {/* Fixed Header */}
      <Header toggleSidebar={toggleSidebar} />
      
      {/* Main Container */}
      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        <Sidebar 
          isSidebarOpen={isSidebarOpen} 
          setIsSidebarOpen={setIsSidebarOpen} 
        />
        
        {/* Main Content Area */}
        <main className="flex-1 overflow-auto">
          <div className="min-h-full p-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
});

export default Layout;